import { render, staticRenderFns } from "./RegisterCardReceive.vue?vue&type=template&id=70403a0e"
import script from "./RegisterCardReceive.vue?vue&type=script&lang=js"
export * from "./RegisterCardReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports